import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HvlNgSharedModule, PrimengSharedModule } from '@hvlng/framework-core/shared';
import { UiSharedModule } from 'ui-shared';
import { HrPerPersonnelSearchComponent } from './hr-per-personnel-search.component';
import { FormGroupDirective } from '@angular/forms';
import { HumanresourcesCommonSharedModule } from 'humanresources-common-shared';

@NgModule({
    declarations: [HrPerPersonnelSearchComponent],
    imports: [CommonModule, PrimengSharedModule, HvlNgSharedModule, UiSharedModule,HumanresourcesCommonSharedModule],
    exports: [HrPerPersonnelSearchComponent],
    providers: [FormGroupDirective],
})
export class HrPerPersonnelSearchModule {}
